// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__WRsGc","loader":"Loader_loader__bFkrf","mltShdSpin":"Loader_mltShdSpin__dnDGi","round":"Loader_round__PRMPG"};